import React, { useState, useEffect } from "react";
import colors from "../ColorConfig/colorconfig";
import SEO from "../../AASeo/Seo";

const organization = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "IDLBAY Private Limited",
  alternateName: "IDLBAY",
  url: "https://idlbay.com",
  logo: "https://idlbay.com/idlbaylogo.png",
  sameAs: [
    "https://www.linkedin.com/company/idlbay/",
    "https://x.com/idlbayPvtLtd",
    "https://www.instagram.com/idlbay.official?igsh=dnIxMm50cmdxNDNy",
    "https://www.facebook.com/profile.php?id=61582746578911",
    "https://www.youtube.com/channel/UCDSb9__-mSLqeyuZYelakcw",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+91-9840841840",
    contactType: "Customer Support",
    areaServed: "IN",
    availableLanguage: ["English", "Tamil"],
  },
  address: {
    "@type": "PostalAddress",
    streetAddress:
      "Office No.1, First Floor, Door No.1, B Narasimhan 3rd Street",
    addressLocality: "T-Nagar, Chennai",
    addressRegion: "Tamil Nadu",
    postalCode: "600017",
    addressCountry: "IN",
  },
};

function Terms() {
  const [termsData, setTermsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Hardcoded terms data
  const hardcodedTermsData = [
    {
      id: "4",
      title: "Acceptance of Terms",
      description: "Welcome to IDLBAY Private Limited.\r\nBy accessing or using our website or services, you acknowledge that you have read, understood, and agreed to be bound by these Terms & Conditions.\r\nIf you do not agree, please refrain from using our website."
    },
    {
      id: "5",
      title: "Scope of Services",
      description: "IDLBAY provides professional IT solutions including but not limited to:\r\n\r\nSoftware and web development\r\n\r\nMobile app development\r\n\r\nDigital marketing and analytics\r\n\r\nCloud solutions and IT consulting\r\n\r\nService-specific terms may apply as part of individual project agreements or proposals."
    },
    {
      id: "6",
      title: "User Responsibilities",
      description: "You agree to:\r\n\r\nUse our website only for lawful purposes.\r\n\r\nNot misuse, interfere, or attempt unauthorized access to our systems.\r\n\r\nProvide accurate and truthful information when engaging with our services.\r\nViolation of these conditions may result in restricted access or termination of service."
    },
    {
      id: "7",
      title: "Intellectual Property Rights",
      description: "All website content — including logos, text, designs, code, and media — is the exclusive property of IDLBAY Private Limited or its partners.\r\nYou may not reproduce, modify, distribute, or republish any material without prior written consent."
    },
    {
      id: "8",
      title: "Confidentiality",
      description: "Any business or technical information exchanged during project discussions or engagements shall remain confidential and protected by both parties."
    },
    {
      id: "9",
      title: "Pricing, Payments & Refunds",
      description: "All pricing and payment terms are communicated transparently in proposals or invoices.\r\n\r\nRefunds, if applicable, will be governed by mutual agreement based on project progress and deliverables.\r\n\r\nDelayed payments may incur service suspension or additional charges."
    },
    {
      id: "10",
      title: "Service Delivery",
      description: "While we strive for perfection, we do not guarantee uninterrupted or error-free service.\r\nIDLBAY shall not be liable for delays or disruptions caused by external factors such as internet outages or third-party dependencies."
    },
    {
      id: "11",
      title: "Limitation of Liability",
      description: "To the fullest extent permitted by law, IDLBAY Private Limited shall not be liable for any indirect, incidental, or consequential damages resulting from your use of our website or services."
    },
    {
      id: "12",
      title: "Third-Party Links",
      description: "Our website may include links to external sites for informational purposes.\r\nWe do not endorse or assume responsibility for the content, policies, or practices of third-party websites."
    },
    {
      id: "13",
      title: "Termination",
      description: "We reserve the right to restrict or terminate access to our services or website at our discretion, without notice, if a user violates these Terms."
    },
    {
      id: "14",
      title: "Indemnification",
      description: "You agree to indemnify and hold IDLBAY Private Limited, its employees, and affiliates harmless from any losses, damages, or legal fees arising from your misuse of our website or violation of these Terms."
    },
    {
      id: "15",
      title: "Governing Law & Jurisdiction",
      description: "These Terms are governed by and construed in accordance with the laws of India.\r\nAll disputes shall be subject to the exclusive jurisdiction of the courts in Chennai, Tamil Nadu."
    },
    {
      id: "16",
      title: "Modifications to Terms",
      description: "We reserve the right to modify, amend, or update these Terms at any time without prior notice.\r\nSuch modifications shall become effective immediately upon their publication on this page.\r\nYour continued access to or use of our services following any changes constitutes your acknowledgment and acceptance of the revised Terms.\r\nAdditionally, please note that certain Terms and Conditions may vary depending on the scope, nature, and requirements of specific projects."
    },
    {
      id: "17",
      title: "Contact Information",
      description: "For inquiries regarding these Terms & Conditions, please contact:\r\n\r\nIDLBAY Private Limited\r\n Office No.1, First Floor, Door No.1, B Narasimhan 3rd Street,\r\nT-Nagar, Chennai, Tamil Nadu – 600017, India\r\nEmail : contact@idlbay.com\r\n\r\n +91 98408 41840"
    }
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    loadHardcodedData();

    // Check if device is mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  // Commented out original API fetching function for future use
  /*
  const fetchTermsData = async () => {
    try {
      const response = await fetch(
        "https://api.dremerz.net/api/DZ_8923_Idlbay_Terms_TermsList"
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setTermsData(data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
      console.error("Error fetching terms data:", err);
    }
  };
  */

  // Load hardcoded data
  const loadHardcodedData = () => {
    try {
      setLoading(true);
      setTermsData(hardcodedTermsData);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error("Error loading hardcoded terms data:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          backgroundColor: colors.white,
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>Loading terms and conditions...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          backgroundColor: colors.white,
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: "2rem",
        }}
      >
        <div style={{ color: colors.error, marginBottom: "1rem" }}>
          Error loading terms: {error}
        </div>
        <button
          onClick={loadHardcodedData}
          style={{
            padding: "0.5rem 1rem",
            backgroundColor: `var(--color-primary)`,
            color: colors.white,
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <>
      <SEO
        title="Terms & Conditions | IDLBAY"
        description="Read the terms and conditions for using IDLBAY's services, website, and digital solutions."
        keywords="terms and conditions, IDLBAY, service terms, user agreement"
        url="https://idlbay.com/terms"
        organization={organization}
      />
      <div style={{ backgroundColor: colors.white, Height: "100vh" }}>
        {/* Header Section */}
        <div
          style={{
            backgroundColor: colors.bodyBlack,
            paddingTop: isMobile ? "1rem" : "6rem", // Reduced from 6rem to 4rem on mobile
            paddingBottom: isMobile ? "2rem" : "4rem", // Reduced from 4rem to 2rem on mobile
            textAlign: "center",
          }}
        >
          <div
            style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1rem" }}
          >
            <h1
              style={{
                fontSize: isMobile ? "2rem" : "clamp(2rem, 5vw, 3.5rem)", // Adjusted for mobile
                fontWeight: "700",
                color: colors.white,
                marginBottom: isMobile ? "0.8rem" : "1rem", // Reduced margin on mobile
                lineHeight: "1.2",
              }}
            >
              Terms of Service
            </h1>
            <div
              style={{
                width: "80px",
                height: "4px",
                backgroundColor: `var(--color-primary)`,
                margin: isMobile ? "0 auto 1rem auto" : "0 auto 1.5rem auto", // Reduced margin on mobile
              }}
            ></div>
            <h2
              style={{
                fontSize: isMobile ? "1rem" : "1.1rem", // Slightly smaller on mobile
                color: colors.gray,
                maxWidth: "900px",
                margin: "0 auto",
                lineHeight: "1.6",
              }}
            >
              Please read these terms and conditions carefully before using our
              services
            </h2>
          </div>
        </div>

        {/* Content Section */}
        <div
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            padding: isMobile ? "2rem 1rem" : "3rem 1rem", // Reduced padding on mobile
          }}
        >
          <div
            style={{
              borderRadius: "12px",
              padding: isMobile ? "1.5rem" : "2rem", // Reduced padding on mobile
            }}
          >
            {termsData.length > 0 ? (
              termsData.map((term, index) => (
                <section
                  key={term.id}
                  style={{
                    marginBottom: isMobile ? "2rem" : "2.5rem", // Reduced margin on mobile
                  }}
                >
                  <h2
                    style={{
                      fontSize: isMobile ? "1.4rem" : "1.8rem", // Smaller font on mobile
                      fontWeight: "600",
                      color: colors.bodyBlack,
                      marginBottom: isMobile ? "0.8rem" : "1rem", // Reduced margin on mobile
                      borderLeft: `4px solid var(--color-primary)`,
                      paddingLeft: "1rem",
                    }}
                  >
                    {index + 1}. {term.title}
                  </h2>
                  <h3
                    style={{
                      color: colors.bodyBlack,
                      lineHeight: "1.7",
                      fontSize: isMobile ? "0.95rem" : "1rem", // Slightly smaller text on mobile
                    }}
                  >
                    {term.description.split("\r\n").map(
                      (paragraph, i) =>
                        paragraph.trim() && (
                          <p
                            key={i}
                            style={{
                              marginBottom: isMobile ? "0.8rem" : "1rem", // Reduced margin on mobile
                            }}
                          >
                            {paragraph.trim()}
                          </p>
                        )
                    )}
                  </h3>
                </section>
              ))
            ) : (
              <div style={{ textAlign: "center", padding: "2rem" }}>
                No terms and conditions available at this time.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Terms;